import { render, staticRenderFns } from "./MiroPicker.vue?vue&type=template&id=49f6873e&"
import script from "./MiroPicker.vue?vue&type=script&lang=js&"
export * from "./MiroPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports